export default __webpack_public_path__ + "static/logo-250a234b9bf7c7f4efb81cf2bae59260.png";